<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  [attr.stroke-width]="strokeWidth"
  stroke-linecap="round"
  stroke-linejoin="round">
  <ng-container [ngSwitch]="name">
    <polyline *ngSwitchCase="'chevron-down'" points="6 9 12 15 18 9" />
    <ng-container *ngSwitchCase="'document'">
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
      <polyline points="17 21 17 13 7 13 7 21" />
      <polyline points="7 3 7 8 15 8" />
    </ng-container>
    <ng-container *ngSwitchCase="'download'">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </ng-container>
    <ng-container *ngSwitchCase="'expand'">
      <polyline points="15 3 21 3 21 9" />
      <polyline points="9 21 3 21 3 15" />
      <line x1="21" y1="3" x2="14" y2="10" />
      <line x1="3" y1="21" x2="10" y2="14" />
    </ng-container>
    <ng-container *ngSwitchCase="'printer'">
      <polyline points="6 9 6 2 18 2 18 9" />
      <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
      <rect x="6" y="14" width="12" height="8" />
    </ng-container>
    <ng-container *ngSwitchCase="'search'">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </ng-container>
    <ng-container *ngSwitchCase="'close'">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </ng-container>
    <ng-container *ngSwitchCase="'eye'">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" />
      <circle cx="12" cy="12" r="3" />
    </ng-container>
    <ng-container *ngSwitchCase="'trash'">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    </ng-container>
    <polyline *ngSwitchCase="'chevron-left'" points="15 18 9 12 15 6" />
    <polyline *ngSwitchCase="'chevron-right'" points="9 18 15 12 9 6" />
    <ng-container *ngSwitchCase="'chevron-first'">
      <polyline points="18 17 13 12 18 7" />
      <polyline points="11 17 6 12 11 7" />
    </ng-container>
    <ng-container *ngSwitchCase="'chevron-last'">
      <polyline points="6 17 11 12 6 7" />
      <polyline points="13 17 18 12 13 7" />
    </ng-container>
  </ng-container>
</svg>
